import * as React from 'react';

import {
  connectToDescriptors,
  IDescriptorProps,
  IJQDescription,
} from '../сonnectToDescriptors';
import { Input } from '../../components/Input';
import { undergroundWalkTimeDescriptors } from '../../constants/descriptors';
import { TTypedThunkDispatch } from '../../types/thunk';
import { getOffersCount } from '../../actions/offersData';
import { Container } from '../../components/Container';
import { Text } from '../../components/Text';
import { SIZE_20, SIZE_80, SIZE_8 } from '../../constants/sizes';
import { getEventValue, debounce } from '@cian/newbuilding-utils';
import { DEFAULT_INPUT_TIMEOUT } from '../../constants/timeouts';
import { clearJsonQueryAction } from '../../actions/filters';

export interface IUndergroundWalkTimeInputProps extends IDescriptorProps<number> {
  getOffersCount(): void;
  clearJsonQuery(value: IJQDescription['value']): void;
}

class UndergroundWalkTimeInputComponent extends React.Component<IUndergroundWalkTimeInputProps> {

  public getOffersCount = debounce(DEFAULT_INPUT_TIMEOUT, this.props.getOffersCount);

  public shouldComponentUpdate(
    {jsonQuery: {underground_walk_time: nextUndergroundWalkTime}}: IUndergroundWalkTimeInputProps,
  ) {
    const {jsonQuery: {underground_walk_time}} = this.props;
    const value = underground_walk_time && underground_walk_time.value ? underground_walk_time.value.lte : '';
    const nextValue = nextUndergroundWalkTime && nextUndergroundWalkTime.value ? nextUndergroundWalkTime.value.lte : '';

    return nextValue !== value;
  }

  public render() {
    const {actionCreator, descriptors, jsonQuery: {underground_walk_time}} = this.props;
    const lte = underground_walk_time && underground_walk_time.value ? underground_walk_time.value.lte : '';

    const handleChange = (type: 'lte') => (event: React.SyntheticEvent) => {
      const value = getEventValue(event);

      if (value) {
        actionCreator(descriptors[0])(parseFloat(value), type);
      } else {
        this.props.clearJsonQuery(value);
      }

      this.getOffersCount();
    };

    return (
      <Container
        display="flex"
        alignItems="center"
      >
        <Text>Не более: </Text>

        <Container
          padding={`0 ${SIZE_20} 0 ${SIZE_8}`}
          width={SIZE_80}
        >
          <Input
            aria-label="Время пешком до метро"
            type="number"
            onChange={handleChange('lte')}
            value={lte}
          />
        </Container>
        <Text>мин.</Text>
      </Container>
    );
  }
}

function mapDispatchToProps(dispatch: TTypedThunkDispatch) {
  return {
    getOffersCount: () => {
      dispatch(getOffersCount());
    },
    clearJsonQuery: (value: IJQDescription['value']) => {
      dispatch(clearJsonQueryAction('underground_walk_time', value));
    },
  };
}

export const UndergroundWalkTimeInput = connectToDescriptors(
  undergroundWalkTimeDescriptors,
  mapDispatchToProps,
)(UndergroundWalkTimeInputComponent);
